import type { AxiosResponse } from "axios";

import type { CancelableAxiosPromise, S3PutSuccess } from "./base";
import { baseService } from "./base";

type UploadData = {
  name: string;
  duration: number;
  file?: File;
  folderId?: string;
  s3Url?: string;
  mimeType?: string;
};

type OptionalUploadField = "file" | "folderId" | "s3Url" | "mimeType";

const OPTIONAL_UPLOAD_FIELDS: Array<{
  field: OptionalUploadField;
  apiFieldName: string;
}> = [
  { field: "file", apiFieldName: "file" },
  { field: "folderId", apiFieldName: "folder_id" },
  { field: "s3Url", apiFieldName: "s3_url" },
  { field: "mimeType", apiFieldName: "mime_type" },
];

const userContentService = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/user-contents");
  },

  edit(
    contentId: string,
    duration: number,
    name: string,
    tag: string,
  ): Promise<AxiosResponse | S3PutSuccess> {
    const data = {
      duration,
      name,
      tag,
    };

    return baseService.put(`/api/user-content/${contentId}`, data);
  },

  archive(contentIds: string[]): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/user-contents/archive", { contentIds });
  },

  upload(uploadData: UploadData): CancelableAxiosPromise {
    const { name, duration } = uploadData;

    const data = new FormData();
    data.append("name", name);
    data.append("duration", String(duration));

    OPTIONAL_UPLOAD_FIELDS.forEach(({ field, apiFieldName }) => {
      const val = uploadData[field];

      if (val instanceof Blob) {
        data.append(apiFieldName, val);
      } else if (val !== undefined && val !== null) {
        data.append(apiFieldName, String(val));
      }
    });

    return baseService.post("/api/user-content", data, "form");
  },
};

export default userContentService;
export { userContentService };
